export default {
  data() {
    return {
      enterpriseTwoOptionList: [
        {
          SETTB99ID: '',
          SETTB99CA00: '全部',
        },
      ],
      filteredEnterpriseOptions: [],
      enterpriseTwo: '',
    }
  },
  methods: {
	  //厂家筛选
    enterprise2Options() {
      var postData = {}
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        postData = {
          type: 2,
          ORMTB400ID: this.uobj.ormtb410.ORMTB410ID,
        }
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
        postData = {
          type: 1,
          ORMTB400ID: this.uobj.ormtb400.ORMTB400ID,
        }
      }
      var List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
      this.axios.post('/set/settb100/selectSettb100ByCa02', postData).then(res => {
        if (res.data.code == 200) {
          var data = res.data.data
          this.enterpriseTwoOptionList = [...List, ...data]
          this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
          if (this.enterpriseTwoOptionList.length == 2) {
            this.enterpriseTwo = this.enterpriseTwoOptionList[1].SETTB99ID
            if (typeof this.materielMoPost === 'function') this.materielMoPost()
          }
          if (typeof this.onEnterpriseLoaded === 'function') this.onEnterpriseLoaded(data)
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      })
    },
	
	
    filterEnterprise(query) {
      if (!query) {
        this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
        return
      }
      const q = query.toLowerCase()
      this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.filter(item =>
        (item.SETTB99CA00 || '').toLowerCase().includes(q) ||
        (item.SETTB99CA00PY || '').toLowerCase().includes(q)
      )
    },
	
	//ormtb805/getEidByMaterial厂家筛选
    loadEidByMaterial() {
      const List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
      this.axios.post('/ormtb805/getEidByMaterial', { SETTB99CA00: '' }).then(res => {
        if (res.data.code == 200) {
          this.enterpriseTwoOptionList = [...List, ...res.data.data]
          this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      })
    },
    filterEidEnterprise(query) {
      if (!query) {
        this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
        return
      }
      const q = query.toLowerCase()
      this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.filter(item =>
        (item.SETTB99CA00 || '').toLowerCase().includes(q) ||
        (item.SETTB99CA00_PY || '').toLowerCase().includes(q)
      )
    },
    // ormtb807/querySettb99 厂家筛选
    loadQuerySettb99() {
      const List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
      this.axios.post('/ormtb807/querySettb99').then(res => {
        if (res.data.code == 200) {
          this.enterpriseTwoOptionList = [...List, ...res.data.data]
          this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      })
    },
    filterSettb99Enterprise(query) {
      if (!query) {
        this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
        return
      }
      const q = query.toLowerCase()
      this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.filter(item =>
        (item.SETTB99CA00 || '').toLowerCase().includes(q) ||
        (item.SETTB99CA00_PY || '').toLowerCase().includes(q)
      )
    },
  },
}
